import styled, { CreateStyled } from '@emotion/styled';
export default styled as CreateStyled;
